import * as yup from 'yup';

export const elementarSchema = yup.object({
  gefaehrdet: yup.boolean().default(false),
  betroffen: yup.boolean().default(false),
  erdbeben: yup.boolean().default(false),
  erdfall: yup.boolean().default(false),
  erdrutsch: yup.boolean().default(false),
  schneedruck: yup.boolean().default(false),
  lawinen: yup.boolean().default(false),
  ueberschwemmung: yup.boolean().default(false),
  rueckstau: yup.boolean().default(false),
  schadenjahr: yup
    .date()
    .nullable()
    .default(null)
    .when('betroffen', {
      is: (val: boolean) => val,
      then: yup.date().required(),
    }),
  schadenhoehe: yup
    .number()
    .nullable()
    .default(null)
    .when('betroffen', {
      is: (val: boolean) => val,
      then: yup.number().required(),
    }),
  bereinigt: yup.boolean().default(false),
  schadenursache: yup
    .string()
    .default('')
    .when('betroffen', {
      is: (val: boolean) => val,
      then: yup.string().required(),
    }),
  gegenmassnahmen: yup
    .string()
    .default('')
    .when('betroffen', {
      is: (val: boolean) => val,
      then: yup.string().required(),
    }),
  bemerkungen: yup
    .string()
    .default('')
    .when('betroffen', {
      is: (val: boolean) => val,
      then: yup.string().required(),
    }),
});
